import React, { FC, useContext, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { hicContext } from 'src/app/hooks/context/context'
import { useGrant } from './grant-hooks'

type IsUserInRoleProp = {
  roles: string[]
  noGrantContents?: React.ReactElement
  noGrantRoute?: string
}

/**
 * Content is visible if user is in one of the roles required.
 * @param props
 * @returns
 */
export const IfUserInRole: FC<IsUserInRoleProp> = (props) => {
  const { context } = useContext(hicContext)
  const navigate = useNavigate()
  const { isInRole } = useGrant()

  const isGranted = useMemo(() => {
    return isInRole(props.roles)
  }, [context, props.roles])

  useEffect(() => {
    if (props.noGrantRoute) {
      isGranted ? undefined : navigate(props.noGrantRoute)
    }
  }, [props.noGrantRoute, isGranted])

  if (context.loading) {
    return <>Please wait...</>
  } else {
    if (isGranted) return <>{props.children}</>
    else if (props.noGrantContents) return props.noGrantContents
  }
  return <></>
}
